import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NbDialogRef } from "@nebular/theme";
import { Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import { convertTimestamp } from "../../@core/utils/convertTimestamps.service";
import { Receipt } from "../../models/receipt.model";
import Shop from "../../models/shop.model";

import { ReceiptService } from "../../services/receipt.service";

@Component({
  selector: "ngx-dialog-view-receipt",
  templateUrl: "dialog-view-receipt.component.html",
  styleUrls: ["dialog-view-receipt.component.scss"],
})
export class DialogViewReceiptComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() shopId?: string;
  @Input() shop?: Shop = new Shop();

  @Input() receipt?: Receipt;
  @Input() receiptId?: string;
  @Input() mode?: string; //receipt / order

  loading: boolean = false;

  constructor(
    protected ref: NbDialogRef<DialogViewReceiptComponent>,
    private receiptService: ReceiptService,
  ) {}

  ngOnInit() {
    if (!this.receipt && this.receiptId) {
      //load receipt
      this.loading = true;

      this.receiptService
        .getReceipt(this.shopId, this.receiptId)
        .then((doc) => {
          if (doc.exists) {
            this.receipt = new Receipt();
            this.receipt = doc.data();
            this.receipt.id = this.receiptId;
            this.receipt.createdOn = convertTimestamp(doc.data().createdOn);
            this.receipt.issueDate = convertTimestamp(doc.data().issueDate);
            this.receipt.deliveryDate = doc.data().deliveryDate
              ? convertTimestamp(doc.data().deliveryDate)
              : new Date();
          }
          console.log("getReceipt:", this.receipt);

          this.loading = false;
        })
        .catch((err) => {
          console.log("getReceipt:null");

          this.loading = false;
        });
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onDelete(id) {
    console.log("DialogViewReceiptComponent/onDelete:", id);
    this.ref.close(id);
  }

  close() {
    this.ref.close();
  }
}
